function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "#000",
  fillRule: "nonzero",
  stroke: "#000",
  strokeWidth: .2
}, React.createElement("path", {
  d: "M6.2 10.284c1.228 0 2.228-.96 2.228-2.142C8.428 6.961 7.428 6 6.2 6c-1.228 0-2.228.96-2.228 2.142 0 1.181 1 2.142 2.228 2.142zm0-3.515c.787 0 1.428.616 1.428 1.373 0 .756-.64 1.373-1.428 1.373-.787 0-1.428-.616-1.428-1.373 0-.756.64-1.373 1.428-1.373z"
}), React.createElement("path", {
  d: "M1 1v20h20V1H1zm.8.77h18.4v10.279l-4.13-3.64a.408.408 0 0 0-.566.024l-3.917 4.126-1.897-1.824a.412.412 0 0 0-.547-.017l-6.694 5.667H1.8V1.769zm18.4 18.46H1.8v-3.076h18.4v3.077zM3.66 16.386l5.73-4.85 4.12 3.961c.156.15.41.15.566 0a.374.374 0 0 0 0-.544l-1.923-1.849 3.672-3.866 4.375 3.855v3.293H3.66z"
}));

const SvgComponent = props => React.createElement("svg", _extends({
  width: 22,
  height: 22,
  viewBox: "0 0 22 22"
}, props), _ref);

export default __webpack_public_path__ + "static/media/image-post-copy.7a290f30.svg";
export { SvgComponent as ReactComponent };